/**
 * Global double-click mousedown guard: suppresses browser word-at-a-time selection expansion
 * (second click of dbl‑click sequence) everywhere except editable / interactive regions.
 */
export const DBLCLICK_SELECTION_GUARD_IGNORE_SELECTOR = [
  'button',
  'a',
  'input',
  'textarea',
  'select',
  'label',
  'option',
  'summary',
  'video',
  'audio',
  'iframe',
  'pre',
  'code',
  '[contenteditable="true"]',
  '[role="button"]',
  '[role="switch"]',
  '[role="tab"]',
  '[role="menuitem"]',
  '[role="textbox"]',
  '[role="separator"]',
  '[data-chat-input]',
  '[data-quote-button]',
  '[data-radix-popper-content-wrapper]',
  '[data-radix-popover-content]',
  '[data-radix-dialog-content]',
  '[cmdk-root]',
].join(', ')

export function bypassDoubleClickSelectionGuard(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false
  return !!target.closest(DBLCLICK_SELECTION_GUARD_IGNORE_SELECTOR)
}

/** Mount on document capture; detach on teardown. Safe to call multiple times if each unsubscribes. */
export function attachGlobalDoubleClickSelectionGuard(): () => void {
  const onMouseDown = (e: MouseEvent) => {
    if (e.detail !== 2) return
    if (bypassDoubleClickSelectionGuard(e.target)) return
    e.preventDefault()
    window.getSelection()?.removeAllRanges()
  }
  document.addEventListener('mousedown', onMouseDown, true)
  return () => document.removeEventListener('mousedown', onMouseDown, true)
}
